import { z } from "zod";
import { emailSchema, isoDateSchema, phoneSchema } from "./common.js";
export const bookingTypeSchema = z.enum(["VERDIVURDERING", "SALG", "ANALYSE"]);
export const bookingStatusSchema = z.enum([
    "PENDING",
    "CONFIRMED",
    "COMPLETED",
    "CANCELLED",
    "NO_SHOW",
]);
export const bookingPreRegistrationItemSchema = z
    .object({
    id: z.string().min(1).max(64).optional(),
    description: z.string().max(500).optional(),
    estimatedKarat: z.number().int().min(1).max(24).nullable().optional(),
    estimatedWeightGrams: z.number().nonnegative().max(100_000).nullable().optional(),
    notes: z.string().max(1000).optional(),
})
    .refine((v) => (v.description?.trim().length ?? 0) > 0 ||
    v.estimatedKarat != null ||
    v.estimatedWeightGrams != null ||
    (v.notes?.trim().length ?? 0) > 0, "Fyll inn minst én detalj på gjenstanden");
export const createBookingSchema = z.object({
    manifestId: z.string().min(1).max(64),
    type: bookingTypeSchema,
    scheduledAt: z.number().int().positive(),
    durationMinutes: z.number().int().min(15).max(180),
    customer: z.object({
        name: z.string().min(1).max(120),
        email: emailSchema,
        phone: phoneSchema,
    }),
    notes: z.string().max(2000).optional(),
    preRegistrationItems: z.array(bookingPreRegistrationItemSchema).max(20).optional(),
});
export const adminCreateBookingSchema = z.object({
    manifestId: z.string().min(1).max(64),
    customerUid: z.string().min(1).optional(),
    type: bookingTypeSchema,
    scheduledAt: z.number().int().positive(),
    durationMinutes: z.number().int().min(15).max(180),
    customer: z.object({
        name: z.string().min(1).max(120),
        email: emailSchema.optional(),
        phone: phoneSchema,
    }),
    notes: z.string().max(2000).optional(),
    preRegistrationItems: z.array(bookingPreRegistrationItemSchema).max(20).optional(),
    bypassCapacity: z.boolean().optional(),
});
export const rescheduleBookingSchema = z.object({
    scheduledAt: z.number().int().positive(),
    durationMinutes: z.number().int().min(15).max(180).optional(),
    bypassCapacity: z.boolean().optional(),
});
export const bookingActionSchema = z.object({
    action: z.enum(["confirm", "complete", "no-show", "cancel"]),
});
export const cancelBookingSchema = z.object({ reason: z.string().max(200).optional() }).default({});
export const startBookingPaymentSchema = z
    .object({ returnUrl: z.string().url().max(500).optional() })
    .default({});
export const bookingAvailabilityQuerySchema = z.object({
    manifestId: z.string().min(1),
    date: isoDateSchema,
    type: bookingTypeSchema,
});
export const availabilitySlotSchema = z.object({
    startAt: z.number(),
    endAt: z.number(),
});
export const bookingAvailabilityResponseSchema = z.object({
    date: z.string(),
    durationMinutes: z.number(),
    slots: z.array(availabilitySlotSchema),
});
export const createBookingResponseSchema = z.object({
    id: z.string(),
    paymentRequired: z.boolean(),
});
export const adminCreateBookingResponseSchema = z.object({ id: z.string() });
export const bookingActionResponseSchema = z.object({ status: bookingStatusSchema });
export const rescheduleBookingResponseSchema = z.object({ rescheduled: z.literal(true) });
export const cancelBookingResponseSchema = z.object({ cancelled: z.literal(true) });
export const startBookingPaymentResponseSchema = z.object({
    checkoutUrl: z.string(),
    sessionId: z.string().nullish(),
    orderId: z.string().nullish(),
    reused: z.boolean(),
});
